// 单文件引入方式

import InputField from './ZuiInputField.vue'

export default {
  install(Vue) {
    Vue.component('ZuiInputField', InputField)
  }
}

export { InputField }
